var _defineProperty = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/defineProperty");

var _toConsumableArray = require("/codebuild/output/src133026617/src/hopin-web/node_modules/@babel/runtime/helpers/toConsumableArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Sentry = require('@sentry/react');

var Tracing = require('@sentry/tracing');

exports.onClientEntry = function (_, pluginParams) {
  if (pluginParams === undefined) {
    return;
  }

  pluginParams._metadata = pluginParams._metadata || {};
  pluginParams._metadata.sdk = {
    name: 'sentry.javascript.gatsby',
    packages: [{
      name: 'npm:@sentry/gatsby',
      version: Sentry.SDK_VERSION
    }],
    version: Sentry.SDK_VERSION
  };

  var integrations = _toConsumableArray(pluginParams.integrations || []);

  if (Tracing.hasTracingEnabled(pluginParams) && !integrations.some(function (ele) {
    return ele.name === 'BrowserTracing';
  })) {
    integrations.push(new Tracing.Integrations.BrowserTracing(pluginParams.browserTracingOptions));
  }

  Tracing.addExtensionMethods();
  Sentry.init(_objectSpread(_objectSpread({
    autoSessionTracking: true,
    environment: process.env.NODE_ENV || 'development',
    // eslint-disable-next-line no-undef
    release: __SENTRY_RELEASE__,
    // eslint-disable-next-line no-undef
    dsn: __SENTRY_DSN__
  }, pluginParams), {}, {
    integrations: integrations
  }));
  window.Sentry = Sentry;
};